import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {NeighborhoodDetail} from "./neighborhood-detail";

const NeighborhoodDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/neighborhoods');
    }

    return (
        <NeighborhoodDetail id={id} onClose={onClose}/>
    )

});

export default NeighborhoodDetailPage;